import { HookResult, Ng2StateDeclaration, StateService, Transition, TransitionHookFn, UIInjector, UIRouter, UrlService } from "@uirouter/angular";
import { AirlineService } from "../../commons/services/airline.service";
import { AuthService } from "../../commons/services/auth.service";
import { StorageService } from "../../commons/services/storageService.service";
import { LogincallbackComponent } from "./logincallback.component";
import { TrackingService } from "app/commons/services/tracking.service";


export const loginStateDeclaration: Ng2StateDeclaration = {
    name: 'login',
    url: '/login'
}

export const loginCallbackStateDeclaration: Ng2StateDeclaration = {
    name: 'logincallback',
    url: '/logincallback',
    component: LogincallbackComponent,
    data: {
        hidePreloader: true
    }
}

export function loginStateConfigFn(router: UIRouter) {
    router.transitionService.onEnter({ to: 'logincallback' }, autenticate as TransitionHookFn);
    router.transitionService.onBefore({ to: 'login' }, returnTo);
    router.transitionService.onSuccess({ to: 'login' }, _login)
}

function _login(transition: Transition) {
    return transition.injector().get<AuthService>(AuthService).login();
}

function returnTo(transition: Transition): HookResult {
    const injector = transition.injector();
    const auth = injector.get<AuthService>(AuthService);
    return auth.isAuthenticated()
        .then(authenticated => {
            if (transition.from().name === '' && authenticated) {
                return injector.get(StateService).target('openairdashboard');
            }
        });
}

function autenticate(transition: Transition) {
    const injector = transition.injector();
    const auth = injector.get<AuthService>(AuthService);
    return auth
        .handleAuthentication()
        .then(userData => {
            return injector.get<AirlineService>(AirlineService)
                .getAirlineList(userData.grantedTenants)
                .then(() => userData)
        })
        .then(userData => auth.saveAirlineOnStorage(userData))
        .then(profile => injector.get<TrackingService>(TrackingService).trackLogIn(profile))
        .then(() => returnToLastUrl(injector, transition))
        .catch(error => {
            console.error(error);
            return (error?.error == 'unauthorized') ? null : returnToLastUrl(injector, transition);
        });
}

function returnToLastUrl(injector: UIInjector, transition: Transition): void {
    const storage = injector.get(StorageService);
            const $url = injector.get(UrlService);
            const parts = storage.session.get.lastUrlParts();
            const lastUrl = storage.session.get.lastUrl();
            if(lastUrl && parts) {
                const urlReplaceRegex = /(^.+\/list).*/;
                const containsListState = urlReplaceRegex.test(lastUrl);
                storage.session.remove.lastUrl();
                storage.session.remove.lastUrlParts();
                if(containsListState) {
                    const path = parts.path.replace(/(^.+\/list).*/, '$1');
                    const url = !parts.search ? path : Object.keys(parts.search)
                        .reduce((acc, key) => {
                            if(key.startsWith('utm_') || key.startsWith('appcue')) acc = `${acc}${key}=${parts.search[key]}&`;
                            return acc
                        }, `${path}?`)
                    transition.abort();
                    $url.url(url, true);
                } else {
                    transition.abort();
                    $url.url(lastUrl, true);
                }
            }
            else {
                transition.abort();
                $url.url("/", true);
                return;
            }
}
